import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelect } from './GridFilterSelect';
import { CompanyStateEnum } from '@api/models/enums/CompanyStateEnum';

const options = Object.values(CompanyStateEnum);

interface Props {
  value?: CompanyStateEnum;
  onChange: (value?: CompanyStateEnum) => void;
}

export const GridFilterCompanyState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelect
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: CompanyStateEnum) => option}
      getOptionName={(option: CompanyStateEnum) => t(`entityState.${option}`)}
    />
  );
};
